import { Component, OnInit } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';
import { AuthenticationService } from 'src/app/core/services/auth.service';

declare global {
  interface Window {
    dataLayer: any[];
  }
}

@Component({
  selector: 'app-contact',
  templateUrl: './contact.component.html',
  styleUrls: ['./contact.component.scss']
})
export class ContactComponent implements OnInit {

  showOverlay = true;

  constructor(
    private formBuilder: FormBuilder,
    private toastr: ToastrService,
    private router: Router,
    private auth_ser: AuthenticationService
  ) {}

  // Main Query Form
  QueryForm = this.formBuilder.group({
    name: ['', [Validators.required]],
    email: ['', [Validators.required, Validators.email]],
    phone_nu: ['', [Validators.required]],
    message: ['', [Validators.required]],
    subject: ['', [Validators.required]]
  });

  // Demo Request Form
  demoForm = this.formBuilder.group({
    first_name: ['', Validators.required],
    last_name: ['', Validators.required],
    email: ['', [Validators.required, Validators.email]],
    phone: ['', Validators.required],
    message: ['', Validators.required]
  });

  ngOnInit(): void {
    this.showOverlay = false;
  }

  formsubmit() {
    if (this.QueryForm.valid) {
      console.log("Query Form Data:", this.QueryForm.value);
      this.toastr.success("Query submitted successfully!");
    } else {
      this.toastr.error("Please fill all required fields in Query form");
    }
  }

  submit_demo() {
    if (this.demoForm.valid) {
      console.log("Demo Form Data:", this.demoForm.value);
      this.showOverlay =true;
      let data =this.demoForm.value
      this.auth_ser.get_a_demo(data).subscribe((res:any)=>{
        let mes = JSON.parse(res)
        res =mes;
        if(res.success == 'Successfully  Inserted Data'){
          this.showOverlay =false;
          this.demoForm.reset();
          this.toastr.success("Demo request submitted successfully!");

        }
        else{ 
          this.showOverlay =false
        }
      })

    } else {
      this.toastr.error("Please fill all required fields in Demo form");
    }
  }

  onPaste(event: ClipboardEvent) {
    event.preventDefault();
    this.toastr.error("Sorry, unable to paste the content", "Error");
  }

  numericOnly(event: any): boolean {
    let patt = /^[0-9]+$/;
    return patt.test(event.key);
  }
}

// Google Tag
function gtag(arg0: string, arg1: string, arg2: { contact_details: any }) {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push(arguments);
  console.log('gtag function called with:', arg0, arg1, arg2);
}
